var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOptionsH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000018205061487793244180000002856058145695631281_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114 114",
    style: {
      enableBackground: "new 0 0 114 114"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.9,45.2c-1.2-3.1-2.8-5.8-4.8-8.3l4.2-11.5l-16.4-9.5l-8,9.4c-3.1-0.5-6.5-0.5-9.7,0l-8-9.4l-16.4,9.5 L31.9,37c-2.1,2.6-3.7,5.4-4.8,8.3L15,47.5v19.1l12.2,2.1c1.2,3.1,2.8,5.8,4.8,8.3l-4.2,11.5L44.3,98l7.9-9.4 c3.1,0.5,6.5,0.5,9.7,0l8,9.4l16.4-9.4l-4.1-11.8c2.1-2.6,3.7-5.4,4.8-8.3l12-2.1v-19L86.9,45.2z M82.5,63.4l-0.6,1.7 c-1.2,3.5-3,6.6-5.4,9.4l-1.2,1.3L78.9,86l-7.8,4.5l-6.9-8.2l-1.8,0.3c-3.7,0.8-7.3,0.8-10.8,0l-1.8-0.3l-6.9,8.2L35.1,86 l3.6-10.2l-1.2-1.3c-2.4-2.7-4.2-5.8-5.4-9.4l-0.6-1.6l-10.6-2v-8.9l10.6-2l0.6-1.7c1.2-3.5,3-6.6,5.4-9.4l1.2-1.3L35.1,28 l7.8-4.5l6.9,8.2l1.8-0.3c3.7-0.8,7.3-0.8,10.8,0l1.8,0.3l6.9-8.2l7.8,4.5l-3.6,10.2l1.2,1.3c2.4,2.7,4.2,5.9,5.4,9.4l0.6,1.6 l10.6,2v8.9L82.5,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,39.5c-9.6,0-17.5,7.9-17.5,17.5S47.4,74.5,57,74.5S74.5,66.6,74.5,57S66.6,39.5,57,39.5z M57,68.5 c-6.3,0-11.5-5.2-11.5-11.5S50.7,45.5,57,45.5S68.5,50.7,68.5,57S63.3,68.5,57,68.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 114,
    height: 114
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptionsH);
export default __webpack_public_path__ + "static/media/icon_options_h.0ff1fd8bb8f7836451cd6c1336f166d7.svg";
export { ForwardRef as ReactComponent };